import styled from 'styled-components/native';
import { Text } from '../../../ReusableComponents';

export const AboutText = styled(Text)`
  line-height: 25px;
`;
